module.exports = __webpack_public_path__ + "static/img/partner-logo8.78319747.jpg";